import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniInput } from "./UniInput";
import { DAO } from "./DAO";
import { API, ApiResult } from "./API";
import { WS } from "./WS";

export class UniInputDAO {


  static async Insert(uni_option_guid: string, input_code: string): Promise<UniInput> {
    let data = new UniInput();

    data.option_guid = uni_option_guid;
    data.input_code = input_code;

    let refetch_data = await DAO.Insert(UniInput, data);
    return refetch_data;
  }

  static async Insert_新增空白Input(uni_option_guid: string): Promise<UniInput> {
    let data = new UniInput();

    data.option_guid = uni_option_guid;

    let refetch_data = await DAO.Insert(UniInput, data);
    return refetch_data;
  }
  /** 修改指定欄位，DGV修改數值用 */
  static async UpdateOneField(data: UniInput, field: string, value: any) {

    if (field === "input_code" || field === "i_his_code") {
      value = (value as string).trim();// code 系列 自動先 trim(); 
    }

    (data as any)[field] = value;

    let re = await DAO.UpdateOnly(UniInput, data, [field]);

    return re;
  }


  static async Delete(data: UniInput): Promise<number> {
    let effect_rows_cnt = DAO.DeleteByGuid(UniInput, data.guid);
    return effect_rows_cnt;
  }

  static async FetchByGuid(guid: string): Promise<UniInput> {
    let data = await DAO.FetchByGuid(UniInput, guid);
    return data;
  }

  static async Select(option_guid: string | null): Promise<UniInput[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定所屬Option(option_guid)
      + Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniInput, cond);
    return data_list;
  }


  static async DB_SelectInputs_ByFormGuidList(form_guid_list: string[] | null | undefined): Promise<UniInput[]> {

    let api_rslt: ApiResult = await WS.CallWS(
      "uni_input/select_by_form_guid_list",
      { form_guid_list: form_guid_list }
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniInput, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }


}

class Cnd {
  static 指定所屬Option(option_guid: string | null) {
    return ` (option_guid='${option_guid}') `;
  }


  static OrderBy預設排序() {
    return ` ORDER BY sort_no, serno `;
  }

  static 指定特做版本(form_guid: string | null) {
    return ` (form_guid='${form_guid}') `;
  }

  static 指定所屬特作(form_guid_list: string[] | null | undefined) {
    if (form_guid_list == null) {
      return " (1=0) ";
    } else {
      let ary: any[] = [];
      form_guid_list?.forEach((guid: string) => {
        ary.push(`form_guid='${guid}'`)
      })
      return ary.join(' OR ');
    }
  }
}


export function useUniInput(guid: string) {
  const ctx = useAppContext();

  const [_UniInput, set_UniInput] = useState<UniInput | null>(null);

  async function refresh_UniInput() {
    try {
      const data_list = await UniInputDAO.FetchByGuid(guid);
      set_UniInput(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniInput();
  }, [guid]);

  return { _UniInput, set_UniInput, refresh_UniInput }
}


export function useUniInputList(option_guid: string | null) {
  const ctx = useAppContext();

  const [_UniInputList, set_UniInputList] = useState<UniInput[]>([]);

  async function refresh_UniInputList() {
    try {
      const data_list = await UniInputDAO.Select(option_guid);
      set_UniInputList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniInputList();
  }, [option_guid]);

  return { _UniInputList, set_UniInputList, refresh_UniInputList }
}